export default "__VITE_ASSET__DEdl_Hn$__"